import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { Loading } from "../../services/visualLibraryService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  LinkStyled,
  LogoStyled,
  PinItemStyled,
  TextStyled,
  PinContainerStyled,
  LeftBlock,
  RightBlock,
  AlignText,
  StepNumber,
  StepContainer,
  StepText,
  StepTextContainer,
  QRCodeWrapper,
  PinLoginInfoContainer
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { generatePin, loginPin } from "../../services/pinLoginService";
import { routes } from "../../routes";
import FreeLogo from "../../components/FreeLogo";
import { getGlobalButtonInfo } from "../../errors/globalButtons";
import { getWebPortalURL } from "../../services/tvodService";
import QRCodeReact from "react-qr-code";
import { autologin } from "../../services/authenticationService";
import { config } from "../../config/config";
import { checkForUmanagedOrNonChangeableMop } from "../../services/billingService";
import { getLoginRedirectionData } from "../../services/navigationService";
import { getSdk } from "../../services/sdkService";

class PinSignupPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: "",
      isLoading: true,
      timer: null,
      showModal: false,
      isSamsungTV: false,
      linkTvURL: "",
      urlToShow: "",
      extraQueryParams: "",
      locale: localStorage.getItem("locale")
    };
    this.onBack = this.onBack.bind(this);
    this.pollingIntervalTime = 60000; // 60 secs
  }

  async getPin() {
    const pinResponse = await generatePin();
    this.setState({ pin: pinResponse.pin });
  }

  async redirectToHomeWithLoggedInUser(loginPinResponse) {
    const { stateActions } = this.props;
    localStorage.setItem("credentials", loginPinResponse.webToken);
    const data = await autologin();
    if (localStorage && localStorage.locale) {
      data.locale = localStorage.locale;
      data.settings.language = localStorage.locale;
    }
    await stateActions.userLoggedIn(data);
    await stateActions.hideSettingsModal();
    redirectTo.call(this, routes.home, historyMethods.REPLACE);
  }

  async componentDidMount() {
    const configuration = await config.request();
    const clientType = configuration.sdk.clientType;
    const {
      stateActions,
      stateActions: { showSettingsModal, voucherData },
      history
    } = this.props;
    const isFromWelcomePage = history.location && history.location.referrer === "/welcome" ? true : false;
    let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);

    (async () => {
      await this.getPin().then(() => {
        const isSamsungTV = clientType === "samsung-tizen" ? true : false;
        const urlToShow = !isFromWelcomePage ? "auth" : isSamsungTV ? "samsung" : "linktv";
        const linkTvURL = "linktv";
        let extraQueryParams = isSamsungTV ? "&clientType=samsung" : "";
        extraQueryParams += !isFromWelcomePage ? "&auth=true" : "";
        this.setState({ isLoading: false, linkTvURL, urlToShow, isSamsungTV, extraQueryParams });
      });

      this.timer = setInterval(async () => {
        try {
          const loginPinResponse = await loginPin({ pin: this.state.pin });
          if (loginPinResponse.errorCode === 4009) {
            await this.getPin();
          } else if (loginPinResponse.webToken && loginPinResponse.webToken !== "false") {
            clearInterval(this.state.timer);
            clearInterval(this.timer);
            const buttons = [
              {
                ...getGlobalButtonInfo("done"),
                buttonHandler: async () => await this.redirectToHomeWithLoggedInUser(loginPinResponse)
              },
              {
                ...getGlobalButtonInfo("notNow"),
                buttonHandler: async () => await this.redirectToHomeWithLoggedInUser(loginPinResponse)
              }
            ];
            if (isFromWelcomePage) {
              showSettingsModal({
                modalTitle: i18n.get("pages.pinSignUp.modalHeading"),
                modalText: i18n.get("pages.pinSignUp.modalDescription"),
                isSignup: true,
                buttons
              });

              const pollingFinishTime = new Date(Date.now() + 6 * 60 * 1000); // the next five minutes (6 number is because pollingFinishTime - 1)
              this.signupTimer = setInterval(async () => {
                try {
                  const currentDateTime = new Date(Date.now());
                  if (currentDateTime > pollingFinishTime) {
                    clearInterval(this.signupTimer);
                  } else {
                    const result = await getSdk().userManager.get({
                      avoidCache: true,
                      avoidDeepCall: false,
                      avoidDeepCallCache: true
                    });
                    if (result && result.settings && result.settings.addons && result.settings.addons.length > 0) {
                      await this.redirectToHomeWithLoggedInUser(loginPinResponse);
                    }
                  }
                } catch (error) {
                  console.log(error);
                }
              }, this.pollingIntervalTime);
            } else {
              localStorage.setItem("credentials", loginPinResponse.webToken);
              const data = await autologin();
              stateActions.userLoggedIn(data);
              if (voucherData && voucherData.autoRedeem) {
                let path = await checkForUmanagedOrNonChangeableMop.call(this);
                if (path) {
                  redirectTo.call(this, path, null, historyMethods.REPLACE);
                }
              } else {
                redirectPath === "/login" || redirectPath === "/player"
                  ? redirectTo.call(this, routes.home, historyMethods.REPLACE)
                  : history[navigationMode](redirectPath);
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }, 5000);
    })();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.signupTimer) {
      clearInterval(this.signupTimer);
    }
  }

  onBack() {
    const { applicationState, location, history } = this.props;
    if (applicationState && applicationState.voucherData) {
      redirectTo.call(this, routes.landing, null, historyMethods.REPLACE);
      return true;
    }
    const hasHistoryState = !!(location && location.state);
    if (hasHistoryState && location.state && location.state.backDestination) {
      const backDestination = location.state && location.state.backDestination;
      const backDestinationPathname = backDestination.pathname || backDestination;
      history.replace(backDestinationPathname);
      return true;
    }
    redirectTo.call(
      this,
      location.state && location.state.pathName ? location.state.pathName : routes.home,
      null,
      historyMethods.REPLACE
    );
    return true;
  }

  render() {
    const {
      applicationState: { userLocale: locale }
    } = this.props;
    const { pin, linkTvURL, urlToShow, extraQueryParams } = this.state;
    return (
      <>
        <LandingPageStyled>
          {this.state.isLoading && <Loading overlay />}
          <PinLoginInfoContainer>
            <LeftBlock userLocale={locale}>
              <LandingContainerStyled>
                <TextStyled rank="1" text={i18n.get("pages.pinSignUp.heading")} size="large" />
                <StepContainer userLocale={locale}>
                  <StepNumber>1</StepNumber>
                  <StepTextContainer>
                    <StepText rank="3" text={i18n.get("pages.pinSignUp.step1")} size="medium" />
                    <br />
                    <LinkStyled rank="2">{`starzplay.com/${urlToShow}`}</LinkStyled>
                  </StepTextContainer>
                </StepContainer>
                <StepContainer userLocale={locale}>
                  <StepNumber>2</StepNumber>
                  <StepTextContainer>
                    <StepText rank="3" text={i18n.get("pages.pinSignUp.step2")} size="medium" />
                  </StepTextContainer>
                </StepContainer>
                <StepContainer userLocale={locale}>
                  <StepNumber>3</StepNumber>
                  <StepTextContainer>
                    <StepText rank="3" text={i18n.get("pages.pinSignUp.step3")} size="medium" />
                    <PinContainerStyled userLocale={locale}>
                      {this.state.pin.split("").map((v, i) => (
                        <PinItemStyled userLocale={locale} key={`pin-${i}-${v}`}>
                          {v}
                        </PinItemStyled>
                      ))}
                    </PinContainerStyled>
                  </StepTextContainer>
                </StepContainer>
              </LandingContainerStyled>
            </LeftBlock>
            <RightBlock userLocale={locale}>
              <AlignText>
                <LogoStyled>
                  <FreeLogo />
                </LogoStyled>
              </AlignText>
              <QRCodeWrapper>
                <QRCodeReact value={`${getWebPortalURL()}/${linkTvURL}?pin=${pin}${extraQueryParams}`} size={432} />
              </QRCodeWrapper>
            </RightBlock>
          </PinLoginInfoContainer>
        </LandingPageStyled>
      </>
    );
  }
}

export default withAppState(withSubtheme(PinSignupPage));
